export function NotFound({ homeHref = '/' }: { homeHref?: string }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <p className="text-xs uppercase tracking-[0.3em] text-primary mb-3">Error 404</p>
      <h1 className="text-4xl sm:text-5xl font-semibold mb-3">Page not found</h1>
      <p className="text-muted-foreground max-w-md mb-8">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <a href={homeHref} data-testid="not-found-home-link"
         className="rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:opacity-90 transition-opacity">
        Back to home
      </a>
    </div>
  );
}
